/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Patient } from '../../models/patient';

export interface PatientGetPatientDetails$Params {
  practiceId?: string | null;
  personId?: string | null;
}

export function patientGetPatientDetails(http: HttpClient, rootUrl: string, params?: PatientGetPatientDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<Patient>> {
  const rb = new RequestBuilder(rootUrl, patientGetPatientDetails.PATH, 'get');
  if (params) {
    rb.query('practiceId', params.practiceId, {});
    rb.query('personId', params.personId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Patient>;
    })
  );
}

patientGetPatientDetails.PATH = '/patient/GetPatientDetails';
